import { CompareTableItem } from '@adapters/bigcommerce/types/compareTable';
import { MecProduct } from '@adapters/bigcommerce/types/product';
import { hasSellableColourway } from '@adapters/bigcommerce/hooks/product/variantAvailability';
import { isCompareProductAvailable } from '@utils/comparison/isCompareProductAvailable';
import { resolveCompareImageSrc } from '@utils/comparison/resolveCompareImageSrc';

export const MIN_COMPARE_COLUMNS = 2;

export type CompareProductsByCode = ReadonlyMap<string, MecProduct>;

export const getVisibleCompareItems = <Item extends CompareTableItem>(
  items: readonly Item[],
  productsByCode: CompareProductsByCode
): Item[] =>
  items.filter((item) => {
    const product = productsByCode.get(item.id);
    if (!product) return true;

    return (
      isCompareProductAvailable(product) &&
      hasSellableColourway(product) &&
      !!resolveCompareImageSrc(item.image, product)
    );
  });

export const isProductCompareTableShown = ({
  seedProduct,
  items,
  productsByCode,
}: {
  seedProduct: MecProduct | null | undefined;
  items: readonly CompareTableItem[];
  productsByCode: CompareProductsByCode;
}): boolean =>
  isCompareProductAvailable(seedProduct) &&
  getVisibleCompareItems(items, productsByCode).length >= MIN_COMPARE_COLUMNS;
